import { C } from "../theme/colors";

export default function Section({ children, alt=false, style={} }) {
  return (
    <section style={{background: alt ? C.bgAlt : C.white, padding:"37px 40px", ...style}}>
      <div style={{maxWidth:1260,margin:"0 auto"}}>{children}</div>
    </section>
  );
}
